import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import { FlexBoxProps, FlexRow } from '@xylabs/sdk-react'
import React from 'react'
import { FaAngleDown } from 'react-icons/fa'

import { Erc721MetaDataLoader } from '../../../Contexts'
import { Erc721DescriptionProperty, Erc721ImageProperty, Erc721NameProperty, Erc721TitleProperty } from '../../../Properties'

const Erc721PropertyArea: React.FC<FlexBoxProps> = (props) => {
  return (
    <FlexRow paper {...props}>
      <Accordion style={{ flexGrow: 1 }}>
        <AccordionSummary>
          <Box alignItems="center" display="flex" flexGrow={1} justifyContent="space-between">
            <Typography variant="caption">Erc721 Properties</Typography>
            <FaAngleDown />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Erc721MetaDataLoader>
            <Box alignItems="stretch" display="flex" flexDirection="column" flexGrow={1}>
              <Erc721NameProperty />
              <Erc721TitleProperty />
              <Erc721DescriptionProperty />
              <Erc721ImageProperty />
            </Box>
          </Erc721MetaDataLoader>
        </AccordionDetails>
      </Accordion>
    </FlexRow>
  )
}

export default Erc721PropertyArea
